import React from "react";
import Body from "./Body";

const Advertising = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Advertising;
